// Create a global for access between scripts (including taconite).
// Added to the window object to prevent webpack minification renaming the global variable.
// Not pretty, but it will have to do unless I use a data-reactive view framework such as VueJs or React.
window.tradePortal = {
    // Will be overwritten later by an inline script due to the CSP nonce being dynamically generated.
    csp_nonce: ''
};